import React from 'react'
import Swal from 'sweetalert2'
import i18n from 'sharedKernel/i18n/translate/config'
import { PopUpContainer, PopUpContent, PopUpHeader, PopUpParagraph, PopUpTitle } from './style'
import '../style.css'
import { renderToString } from 'react-dom/server'

export interface ConfirmationProps {
  title: string
  message: string | JSX.Element
  onConfirm?: () => void
  confirmButtonText?: string
}

export const showConfirmationPopUp = ({ title, message, onConfirm, confirmButtonText = i18n.t('Confirm') }: ConfirmationProps): void => {
  const content = (
    <PopUpContainer>
      <PopUpHeader>
        <PopUpTitle>{title}</PopUpTitle>
      </PopUpHeader>
      <PopUpContent>
        <PopUpParagraph>{message}</PopUpParagraph>
      </PopUpContent>
    </PopUpContainer>
  )

  Swal.fire({
    showCloseButton: true,
    showConfirmButton: true,
    confirmButtonText,
    confirmButtonColor: '#0066B3',
    allowOutsideClick: true,
    showCancelButton: true,
    cancelButtonText: i18n.t('Cancel'),
    customClass: {
      popup: 'confirmation-modal',
      closeButton: 'confirmation-modal-close',
      container: 'confirmation-modal-container'
    },
    html: renderToString(content),
    width: 'min(729px, 100vw)',
    padding: 0,
    backdrop: 'rgba(0,0,0,0.4)'
  }).then((result) => {
    if (result?.isConfirmed && typeof onConfirm === 'function') {
      onConfirm()
    }
  })
}
